(function () {
	const initSlider = () => {
		let announcementSlider;
		const announcementSliders = document.querySelectorAll('.swiper-announcement-slider');

		announcementSliders.forEach((slider, index) => {
			announcementSlider = new Swiper(slider, {
				slidesPerView: 1,
				loop: true,
              navigation: {
                nextEl: '.announcement__button-next',
                prevEl: '.announcement__button-prev',
              },
				autoplay: {
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				},
				on: {
					slideChange: function() {
						this.pagination.render();
						this.pagination.update();
					}
				}
			});
		});
	};

	const destroySlider = () => {
		const announcementSliders = document.querySelectorAll('.announcement-bar');

		announcementSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.product-slider-section');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();
